module.exports = __webpack_public_path__ + "static/media/startOver.16c7f1db.svg";